import { colors } from '../../Colors/colors'

export const remarks = {
   light: {
      common: {
         titleColor: 'text-gray-900'
      }
   },
   dark: {}
}
